import bytes from 'bytes';

/** 1536 → "1.5 KB". */
export function formatBytes(value: number): string {
  return bytes.format(value, { unitSeparator: ' ', decimalPlaces: 1 }) ?? '–';
}
